@file:OptIn(InternalResourceApi::class)

package advent_of_code_compose_2025.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/advent_of_code_compose_2025.composeapp.generated.resources/"

internal val Res.font.montserrat_regular: FontResource by lazy {
      FontResource("font:montserrat_regular", setOf(
        ResourceItem(setOf(), "${MD}font/montserrat_regular.ttf", -1, -1),
      ))
    }

internal val Res.font.source_code_pro_regular: FontResource by lazy {
      FontResource("font:source_code_pro_regular", setOf(
        ResourceItem(setOf(), "${MD}font/source_code_pro_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("montserrat_regular", Res.font.montserrat_regular)
  map.put("source_code_pro_regular", Res.font.source_code_pro_regular)
}
